export default {
  au: {
    title: 'Westfield Australia',
    meta: [
      {
        name: 'description',
        content:
          "Find thousands of products from your favourite retailers across women's and men's fashion, kids, home and decor and more.",
      },
      { name: 'keywords', content: 'sample, something' },
    ],
    country: 'Australia',
    lang: 'en-AU',
    url: 'https://www.westfield.com.au',
  },
  nz: {
    title: 'Westfield New Zealand',
    meta: [
      {
        name: 'description',
        content:
          "Find thousands of products from your favourite retailers across women's and men's fashion, kids, home and decor and more.",
      },
      { name: 'keywords', content: 'sample, something' },
    ],
    country: 'New Zealand',
    lang: 'en-NZ',
    url: 'https://www.westfield.co.nz',
  },
}
